import { cashbackApi } from '@api/index';
import { useQuery } from '@hooks/useQuery';
import { QUERIES } from '@query/queries';

export const useCashbackEstimateQuery = () => {
  return useQuery([QUERIES.CASHBACK_ESTIMATE], () => cashbackApi.getEstimate(), {
    cacheTime: 300000, // 5 minutes
  });
};
